/* eslint-disable linebreak-style */
import publishIcon from './img/publish-icon.png';
import channelsIcon from './img/channels-icon.png';
import testIcon from './img/test-icon.png';
import createFlowIcon from './img/create-flow-icon.png';
export const FirstStepsItemList = [
    { stepIndex: 0, stepLabel: 'stepperOnboarding.home.firstSteps.createFlow.label', isActive: true, itemTemplate: {
            mainText: 'stepperOnboarding.home.firstSteps.createFlow.mainText',
            description: 'stepperOnboarding.home.firstSteps.createFlow.description',
            icon: createFlowIcon,
            redirectUrl: 'auth.application.detail.builder',
            buttonText: 'stepperOnboarding.home.firstSteps.createFlow.buttonText',
            trackingName: 'dashbot-click-build',
        } },
    { stepIndex: 1, stepLabel: 'stepperOnboarding.home.firstSteps.publishFlow.label', isActive: true, itemTemplate: {
            mainText: 'stepperOnboarding.home.firstSteps.publishFlow.mainText',
            description: 'stepperOnboarding.home.firstSteps.publishFlow.description',
            icon: publishIcon,
            redirectUrl: 'auth.application.detail.builder',
            buttonText: 'stepperOnboarding.home.firstSteps.publishFlow.buttonText',
            trackingName: 'dashbot-click-publish',
        } },
    { stepIndex: 2, stepLabel: 'stepperOnboarding.home.firstSteps.testFlow.label', isActive: false, itemTemplate: {
            mainText: 'stepperOnboarding.home.firstSteps.testFlow.mainText',
            description: 'stepperOnboarding.home.firstSteps.testFlow.description',
            icon: testIcon,
            redirectUrl: 'auth.application.detail.builder',
            buttonText: 'stepperOnboarding.home.firstSteps.testFlow.buttonText',
            trackingName: 'dashbot-click-test',
        } },
    { stepIndex: 3, stepLabel: 'stepperOnboarding.home.firstSteps.connectChannels.label', isActive: false, itemTemplate: {
            mainText: 'stepperOnboarding.home.firstSteps.connectChannels.mainText',
            description: 'stepperOnboarding.home.firstSteps.connectChannels.description',
            icon: channelsIcon,
            redirectUrl: 'auth.application.detail.channels',
            buttonText: 'stepperOnboarding.home.firstSteps.connectChannels.buttonText',
            trackingName: 'dashbot-click-channel',
        } },
];
